import ScrollToTop from "react-scroll-to-top";

export const ScrollToTopBtn = ({ isIntroPage }) => {
  if (isIntroPage) {
    return null;
  }
  return <ScrollToTop className="scroll-top" color="white" />;
};
